import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/OrderFormActions";
import * as api from "../../api/OrderFormApi";
import { showSuccessSnackbar, showErrorSnackbar } from "../actions/SnackbarActions";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";

function* getAssemblyResponsibles(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getAssemblyResponsibles(action.payload);
        yield put(actions.setAssemblyResponsibles(data || undefined));
    } catch (error) {
        yield put(actions.setAssemblyResponsibles(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getServiceOrder(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getServiceOrder(action.payload);
        yield put(actions.setServiceOrder(data || undefined));
    } catch (error) {
        yield put(actions.setServiceOrder(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* saveServiceOrder(action) {
    console.log('adasdada');
    try {
        const { data } = yield api.saveServiceOrder(action.payload);
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
}

function* getServiceOrderPlanned(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getServiceOrderPlanned(action.payload);
        yield put(actions.setServiceOrderPlanned(data || undefined));
    } catch (error) {
        yield put(actions.setServiceOrder(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* saveServiceOrderPlanned(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.saveServiceOrderPlanned(action.payload);
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* watchAll() {
    yield takeEvery(actions.Types.GET_ASSEMBLYRESPONSIBLES, getAssemblyResponsibles);
    yield takeEvery(actions.Types.GET_SERVICEORDER, getServiceOrder);
    yield takeEvery(actions.Types.SAVE_SERVICEORDER, saveServiceOrder);
    yield takeEvery(actions.Types.GET_SERVICEORDER_PLANNED, getServiceOrderPlanned);
    yield takeEvery(actions.Types.SAVE_SERVICEORDER_PLANNED, saveServiceOrderPlanned);
}

const OrderFormSaga = [fork(watchAll)];

export default OrderFormSaga;
